$(document).ready(function () {
  const BREAKPOINT = 768;
  $('.question-answer-block').accordion(
    {
      collapsible: true,
      active: window.innerWidth < BREAKPOINT ? false : 0,
      heightStyle: 'content',
      animate: {
        easing: 'easeInOutCubic',
        duration: '300',
      },
      icons: {
        header: 'defaultIcon',
        activeHeader: 'selectedIcon',
      },
    },
    $('.question-answer-block h3[data-omni]').click(function () {
      $(document).trigger('track.trackIstockFaq', {
        content: $(this).attr('data-omni'),
      });
    })
  );
});
